/* eslint-disable no-unused-vars */
import axios from "axios";
import { Get, PostFormData, put } from "../Request";

export default {
  state: {
    Roles: [],
    defaultRolesPermissions: [],
  },
  getters: {
    GetRoles(state) {
      return state.Roles;
    },
    GetDefaultRolesPermissions(state) {
      return state.defaultRolesPermissions;
    },
  },
  actions: {
    async GetRoles({ commit }, payload) {
      return await Get(
        `Role/getall/${payload.page}?pageSize=${payload.pageSize}`
      )
        .then((res) => {
          commit("SetRoles", res.data.roles);

          return res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async SaveRoles({ commit }, payload) {
      return await axios.post(
        `${process.env.VUE_APP_API_URL}/Role/SaveRole`,
        payload,
        {
          headers: {
            "api-security-key": "89343EA2-368C-4ABB-90DE-039BE336D2DD",
          },
        }
      );
    },
    //http://ibaapis.rootpointers.net/api/Role/EditRole
    async EditRoles({ commit }, payload) {
      return await axios.put(
        `${process.env.VUE_APP_API_URL}/Role/EditRole`,
        payload,
        {
          headers: {
            "api-security-key": "89343EA2-368C-4ABB-90DE-039BE336D2DD",
          },
        }
      );
    },
    async GetDefaultRolePermissions({ commit }, payload) {
      return await axios
        .get(`${process.env.VUE_APP_API_URL}/Role/GetDefaultRolePermissions`, {
          headers: {
            "api-security-key": "89343EA2-368C-4ABB-90DE-039BE336D2DD",
          },
        })
        .then((res) => {
          commit("SetRolePermissions", res.data);
          return res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async DeleteRole({ commit }, payload) {
      return PostFormData("Role/DeleteRole", payload).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetRoles(state, payload) {
      state.Roles = payload;
    },
    SetRolePermissions(state, payload) {
      state.defaultRolesPermissions = payload;
    },
  },
};
